import React, { useState, useMemo } from 'react';
import _debounce from 'lodash/debounce';
import SearchInput from 'component/atom/forms/input/searchInput/SearchInput';
import Button from 'component/atom/forms/button/Button';
import PopOver from 'component/atom/moreButton/popOver/PopOver';
import MoreButton from 'component/atom/moreButton/MoreButton';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import styles from './Component.module.scss';
import { useResponsive } from 'assets/styles/breakpoints/breakpoint';
import Select from 'component/atom/forms/select/select/Select';

const TableFilters = ({
  headerData,
  filterButtons,
  query,
  setQuery,
  selectedItems,
  handleExport = () => {},
  handleUploadCSV = () => {},
  filter,
  onInternalSearch = () => {},
}) => {
  const { isMobile, isTablet } = useResponsive();
  const [searchValue, setSearchValue] = useState(query?.searchBy || '');

  const debouncedSearch = useMemo(
    () =>
      _debounce((value) => {
        setQuery({ ...query, searchBy: value });
      }, 500),
    [setQuery, query]
  );

  const handleSearchChange = (name, value) => {
    setSearchValue(value);
    if (headerData?.hasInternalSearch) {
      onInternalSearch(value);
      return;
    }
    debouncedSearch(value);
    setQuery((prevQuery) => ({
      ...prevQuery,
      pageNumber: 1,
    }));
  };

  const popOverItems = [
    ...(headerData?.hasExport
      ? [
          {
            title: 'Export Table',
            handleFunction: handleExport,
          },
        ]
      : []),
    ...(headerData?.hasUploadCSV
      ? [
          {
            title: 'Upload CSV',
            handleFunction: handleUploadCSV,
          },
        ]
      : []),
  ];

  const dropdownItems = filterButtons
    ?.filter((icon) => !icon.foreignState)
    ?.map((icon) => ({
      title: icon.label || icon.name,
      handleFunction: icon.func,
    }));

  const mergedItems = [...dropdownItems, ...popOverItems];
  return (
    <div className={styles.filterCont}>
      <div
        className={`${styles['filter-container']} ${
          headerData?.hasTitle ? styles['flex-wrap'] : ''
        } `}
      >
        {headerData?.hasTitle && (
          <span className={styles['table-title']}>{headerData?.tableName}</span>
        )}
        <div
          className={`${styles.left} ${
            headerData?.hasFilter ? styles.hasFilter : ''
          }`}
          style={{
            flexDirection: headerData?.isReverseFilter ? 'row-reverse' : '',
          }}
        >
          {headerData?.hasFilter && (
            <Select
              options={filter?.options}
              onChange={(e) => filter?.func(e.target.value)}
              value={filter?.value}
              placeholder={filter?.placeholder}
              style={{
                width: headerData?.selectWidth
                  ? headerData?.selectWidth
                  : 'unset',
                flexDirection: 'unset',
              }}
            />
          )}
          {headerData?.hasSearch ? (
            <div
              className={`${headerData?.hasFilter ? styles.search : ''}`}
              style={{
                width: headerData?.searchWidth
                  ? headerData?.searchWidth
                  : '80%',
              }}
            >
              <SearchInput
                onChange={handleSearchChange}
                value={searchValue}
                placeholder='Search'
              />
            </div>
          ) : null}
        </div>
        <div className={styles.right}>
          {filterButtons?.length > 0 ? (
            <>
              {!isMobile &&
                filterButtons &&
                filterButtons
                  ?.filter(
                    (icon) =>
                      icon.foreignState === true && selectedItems.length > 0
                  )
                  ?.map((icon, index) => (
                    <Button
                      label={icon.label}
                      variant={icon.variant}
                      onClick={() => icon.func(selectedItems)}
                      id={icon?.id ? icon?.id : ''}
                      opicBackground
                      key={index}
                    />
                  ))}

              {!isMobile &&
                filterButtons &&
                filterButtons
                  ?.filter((icon) => !icon.foreignState)
                  ?.map((icon, index) =>
                    icon.type === 'icon' ? (
                      <SvgWithBranding
                        type={icon.name}
                        onClick={icon.func}
                        className={styles.icon}
                        key={index}
                      />
                    ) : icon.type !== 'button' ? (
                      <Button
                        label={icon.label}
                        variant={icon.variant}
                        onClick={icon.func}
                        opicBackground
                        id={icon?.id ? icon?.id : ''}
                        key={index}
                        isLoading={icon.isLoading}
                        type={icon?.type ? icon?.type : ''}
                      />
                    ) : (
                      <Button
                        label={icon.label}
                        variant={icon.variant}
                        onClick={icon.func}
                        opicBackground
                        id={icon?.id ? icon?.id : ''}
                        key={index}
                        isLoading={icon.isLoading}
                      />
                    )
                  )}
            </>
          ) : null}

          {headerData?.hasExport || headerData?.hasUploadCSV ? (
            <MoreButton icon='table_more_button' toolTipText='More'>
              <PopOver
                stop
                info={!isMobile ? popOverItems : mergedItems}
                closeOnSelect
              />
            </MoreButton>
          ) : dropdownItems.length > 0 && isMobile ? (
            <MoreButton icon='table_more_button' toolTipText='More'>
              <PopOver stop info={dropdownItems} />
            </MoreButton>
          ) : null}
        </div>
      </div>
      {isMobile && (
        <div className={styles['mobile-actions']}>
          {filterButtons &&
            filterButtons
              ?.filter(
                (icon) => icon.foreignState === true && selectedItems.length > 0
              )
              ?.map((icon, index) => (
                <Button
                  label={icon.label}
                  variant={icon.variant}
                  onClick={() => icon.func(selectedItems)}
                  opicBackground
                  id={icon?.id ? icon?.id : ''}
                  key={index}
                />
              ))}
        </div>
      )}
    </div>
  );
};

export default TableFilters;
